import React from 'react'
import * as styles from './Header.module.css'

import { Link } from 'gatsby'
import Nav from '../Nav'
import ComicHeader from '../comicheader/ComicHeader'
import { StaticImage } from 'gatsby-plugin-image'

export default class Header extends React.Component {
  render() {
    return (
      <header className={styles.header}>
        <ComicHeader />
        <hgroup className={styles.title}>
          <h1 className={styles.maintitle}>
            <Link to="/">
              <StaticImage
                src="../../../static/images/barbarian-meets-coding-title.png"
                title="Barbarian Meets Coding"
                alt="Barbarian Meets Coding"
                layout="fullWidth"
                quality={100}
                className={styles.image}
                imgClassName={styles.image}
                loading="eager"
                placeholder="none"
              />
              <span className={styles.barbarian}>barbarian</span>
              <span className={styles.meets}>meets</span>
              <span className={styles.coding}>coding</span>
            </Link>
          </h1>
          <h2>
            <Link to="/">WebDev, UX &amp; a Pinch of Fantasy</Link>
          </h2>
        </hgroup>
        <Nav />
      </header>
    )
  }
}
